// Desktop console top bar (lg+ only) — current section + date on the left,
// desk-state chip and the ⌘K palette hint on the right (console-mockup
// topbar). ConsoleShell mounts it only on desktop, and the classes are
// additionally gated behind lg:, so the Mini App below lg renders no topbar
// at all — byte-for-byte as before.

import { useLocation } from 'react-router-dom';
import { fmtWeekday } from '../lib/format';
import { screenTitle } from '../lib/routes';
import { NewConsoleDoor } from './v2/NewConsoleDoor';

// THE SCREEN'S NAME COMES FROM THE ONE LABEL TABLE (sweep item 71, 14 Sept
// 2026). This bar used to keep its own prefix list, and every screen that
// landed without a row here read "Home" in the header — four of them on the
// 3 Sept audit, and "Chain activity" over a screen titled Chain after that.
// lib/routes.ts names every route once; screenTitle() is the longest-prefix
// lookup over it.

const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

export function TopBar({ onOpenPalette }: { onOpenPalette: () => void }) {
  const { pathname } = useLocation();
  const today = fmtWeekday(); // Dubai's day, whatever the viewer's clock says

  return (
    <header className="sticky top-0 z-20 hidden h-[52px] shrink-0 items-center justify-between border-b border-stroke bg-panel pl-5 pr-4 lg:ml-[72px] lg:flex">
      <div className="text-body text-tg-hint">
        <span className="font-medium text-tg-text">{screenTitle(pathname)}</span>
        <span className="mx-2 text-brand-muted">/</span>
        <span>{today}</span>
      </div>

      <div className="flex items-center gap-3.5">
        {/* The owner's door to the new console (UI rebuild); nothing for anyone else. */}
        <NewConsoleDoor />
        {/* MirrorHealthChip retired at the v3 cutover (1 Sept 2026) — the
            legacy mirror has nothing to mirror on the fresh books. */}
        <button
          type="button"
          onClick={onOpenPalette}
          className="flex items-center gap-2.5 rounded-md border border-stroke bg-panel-2 px-3 py-1.5 text-meta text-tg-hint transition-colors hover:border-tg-accent"
        >
          Search or command
          <kbd className="rounded border border-stroke bg-panel-3 px-1.5 py-0.5 font-mono text-meta text-tg-text">
            {IS_MAC ? '⌘K' : 'Ctrl K'}
          </kbd>
        </button>
      </div>
    </header>
  );
}
